import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { ApiWalletService } from '@api/_api/api-payment/api-wallet.service';
import { WalletModelsTransformer } from '@api/payment/wallet.transformer';

@Injectable()
export class WalletService {
    constructor(
        private readonly apiWalletService: ApiWalletService, // private userService: UserService
    ) {}

    public getWalletCards(storeId: string, langId: string) {
        return this.apiWalletService
            .getWalletCards(storeId, langId)
            .pipe(map((apiWalletCards) => WalletModelsTransformer.WalletCardsFromApi(apiWalletCards)));
    }
}
